export default __webpack_public_path__ + "40225fb12f15c954f49c7875f67d3d1d.svg";